import { combineReducers } from 'redux';

import { api } from '@/app/api/baseApi';
import { authenticatorReducer } from '@/features/authenticator/authenticatorSlice';
import { bannerReducer } from '@/features/banners/bannerSlice';
import { closeUpReducer } from '@/features/closeUpMap/closeUpSlice';
import { drawerReducer } from '@/features/drawer/drawerSlice';
import { helpReducer } from '@/features/help/helpSlice';
import { mapReducer } from '@/features/mapbox/mapSlice';
import { overlayReducer } from '@/features/overlay/overlaySlice';
import { postReducer } from '@/features/post/postSlice';
import { busStopInfoReducer } from '@/features/real-time-info-bus-stop/busStopInfoSlice';
import { settingsReducer } from '@/features/settings/settingsSlice';
import { snackBarsReducer } from '@/features/snackBars/snackBarsSlice';
import { spotDetailReducer } from '@/features/spot-detail/spotDetailSlice';
import { spotReducer } from '@/features/spot-list/spotSlice';
import { serviceProfileReducer } from '@/profile/serviceProfileSlice';

export const rootReducer = combineReducers({
  authenticator: authenticatorReducer,
  map: mapReducer,
  spot: spotReducer,
  overlays: overlayReducer,
  closeUp: closeUpReducer,
  drawer: drawerReducer,
  spotDetail: spotDetailReducer,
  [api.reducerPath]: api.reducer,
  busStopInfo: busStopInfoReducer,
  banner: bannerReducer,
  help: helpReducer,
  post: postReducer,
  snackBars: snackBarsReducer,
  settings: settingsReducer,
  serviceProfile: serviceProfileReducer,
});
